import { createPopularUsCitiesLinks } from '@tenants/definitions/exp/shared/internal-links';
import { createPopularUsStatesLinks } from '@tenants/definitions/exp/shared/internal-links';
import { HomeConfig } from '@tenants/types/tenant';
import { ROOT_PATH_SUFFIX } from 'data/addresses/go-search/types';

export function createHomeConfig(rootPathSuffix: string = ROOT_PATH_SUFFIX): HomeConfig {
  const homeConfig = {
    heroVideo: '/us-hero-1.mp4',
    joinLink: 'https://join.exprealty.com',
    joinUsSection:{
      title: 'Why Join',
      title2: 'eXp Realty?',
      description: 'When you join eXp Realty, you become part of a global family of agents and partners dedicated to transforming the real estate experience. Learn more about how we empower our agents with world-class education, strategic partnership and stock awards.',
      imageUrl: '/assets/images/exp-homepage/why-join-exp-us.png',
      buttonText: 'Learn More',
      link: '/join-exp',
    },
    internalLinks: [
      createPopularUsCitiesLinks(rootPathSuffix),
      createPopularUsStatesLinks(rootPathSuffix),
    ],
    contentCards: {
      sectionTitleParts: ['With eXp, Possibility', 'Becomes', 'Reality'],
      cards: [
        {
          title: 'Buy With Us',
          image: '/next/assets/images/content-cards/us-buy.jpg',
          titleColor: 'rgba(255, 255, 255, 0.7)',
          backgroundColor: '#163259',
          content: 'Buying a home is one of the most important decisions you will make, and our local experts at eXp Realty are here to make the process as easy as possible.',
          link: '/search?openSearch=true',
          desktopTransform: 'rotate(-5deg)',
          tabletTransform: 'none',
          rounded: true,
          altText: 'A man with his hair in a bun hugging a woman outside of a modern building.',
        },
        {
          title: 'Sell With Us',
          image: '/next/assets/images/content-cards/us-sell.jpg',
          titleColor: 'rgba(255, 255, 255, 0.7)',
          backgroundColor: '#6C82A0',
          content: 'Selling your home can feel like a big project, but our agents are ready to make every step of the journey as smooth as possible. Let an eXp agent be your guide to selling your home like a pro.',
          link: '/sell',
          tabletTransform: 'translateY(3em)',
          translateYTablet: '50',
          altText: 'A smiling family, with two kids playing inside a cardboard box',
        },
        {
          title: 'Find an Agent',
          image: '/next/assets/images/content-cards/us-agent.jpg',
          titleColor: '#163259',
          backgroundColor: '#DAE0E7',
          content: 'Whether you are looking to buy, sell or rent, our experienced and passionate agents are on hand to help make it happen. Find the perfect agent for your needs today!',
          link: '/agents-search',
          desktopTransform: 'rotate(2deg) translateY(-1.5em)',
          tabletTransform: 'none',
          translateYDesktop: '-20',
          altText: 'A group of professionals sitting around a table, engaged in conversation.',
        },
        {
          title: 'Cash Offers',
          image: '/next/assets/images/content-cards/us-cash.jpg',
          titleColor: '#6D6F7C',
          backgroundColor: '#EEEEEE',
          content: 'Discover how you can get cash offers quickly on your home without staging or listing. Our Express Offers platform easily connects individual home owners with investors, avoiding some of the stress of a traditional sale. Move on your own timeline.',
          link: 'https://expressoffers.com/',
          desktopTransform: 'rotate(7deg) translateY(2em)',
          tabletTransform: 'translateY(3em)',
          translateYDesktop: '40',
          translateYTablet: '50',
          rounded: true,
          altText: 'Close-up of hands typing on a laptop.',
        },
      ],
    },
  };
  return homeConfig;
}